import { useLogoutMutation as useLogout } from '../../generated/graphql';

export default useLogout;
